// Carte IN-APP à l'arrivée d'une notification (CCT-97).
//
// En plus de l'incrémentation du badge, un aperçu cliquable s'affiche quelques secondes :
// il mène EXACTEMENT à la même destination que la notification (route mutualisée) et marque
// la notification comme lue. Se ferme seul, ou à la croix.
import { useEffect } from 'react';
import { View, Text, TouchableOpacity, Image, StyleSheet } from 'react-native';
import { useNotifications } from '../context/NotificationsContext';
import { useTheme } from '../context/ThemeContext';
import { getThemeColors } from '../utils/themeStyles';
import { navigateNotificationRoute } from '../utils/notificationRoute';
import { navigateFromAnywhere } from '../navigation/navRef';

const AUTO_DISMISS_MS = 6000;

export default function NotificationToast() {
  const { toast, dismissToast, markRead } = useNotifications();
  const { isDarkTheme } = useTheme();
  const c = getThemeColors(isDarkTheme);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => dismissToast(), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [toast, dismissToast]);

  if (!toast) return null;

  const open = () => {
    if (toast.unread) void markRead(toast.id);
    navigateNotificationRoute({ navigate: (n: any, p: any) => navigateFromAnywhere(n, p) }, toast.route);
    dismissToast();
  };

  return (
    <View pointerEvents="box-none" style={s.wrap}>
      <TouchableOpacity onPress={open} activeOpacity={0.9}
        style={[s.card, { backgroundColor: c.cardBackground, borderColor: c.border, shadowColor: c.cardShadow }]}>
        {toast.senderAvatar ? (
          <Image source={{ uri: toast.senderAvatar }} style={s.avatar} resizeMode="cover" />
        ) : (
          <View style={[s.avatar, { backgroundColor: c.primary, alignItems: 'center', justifyContent: 'center' }]}>
            <Text style={{ color: '#fff', fontWeight: '700' }}>{(toast.senderName || toast.title || '?').slice(0, 1)}</Text>
          </View>
        )}
        <View style={{ flex: 1, minWidth: 0 }}>
          {!!toast.senderName && (
            <Text numberOfLines={1} style={[s.sender, { color: c.textTertiary }]}>{toast.senderName}</Text>
          )}
          <Text numberOfLines={1} style={[s.title, { color: c.textPrimary }]}>{toast.title}</Text>
          <Text numberOfLines={2} style={[s.body, { color: c.textSecondary }]}>{toast.message}</Text>
        </View>
        <TouchableOpacity onPress={dismissToast} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
          <Text style={{ color: c.textTertiary, fontSize: 16, paddingHorizontal: 2 }}>✕</Text>
        </TouchableOpacity>
      </TouchableOpacity>
    </View>
  );
}

const s = StyleSheet.create({
  wrap: { position: 'absolute', top: 12, right: 12, left: 12, alignItems: 'flex-end', zIndex: 9999 },
  card: {
    flexDirection: 'row', alignItems: 'center', gap: 10, maxWidth: 420, width: '100%',
    borderWidth: 1, borderRadius: 12, paddingVertical: 10, paddingHorizontal: 12,
    shadowOffset: { width: 0, height: 3 }, shadowOpacity: 0.2, shadowRadius: 8, elevation: 6,
  },
  avatar: { width: 34, height: 34, borderRadius: 17 },
  sender: { fontSize: 11, marginBottom: 1 },
  title: { fontSize: 13, fontWeight: '700' },
  body: { fontSize: 12, marginTop: 1 },
});
